export const languageChangerObject = {
    'russian': {
        'navigation': {
            0: '',
            1: 'Reviews',
            2: 'About us',
            3: 'Services',
            4: 'Contacts',
        },
        'previewPage': {
            1: 'RNK Tech',
            2: '360° car and van repairs',
            3: 'Advanced diagnostics, complete maintenance, suspension repair, air-conditioning service, and ECU repairs. 17 years of experience in Padua.',
            4: 'Contact us on WhatsApp',
            //5:'100% Доверенный автосервис с локацией в Кишинёве!'//
        },
        'whyUs': {
            1: 'Why choose us?',
            // 2: 'Reasonable prices',
            // 3: 'Специализация на автомобилях, работающих на метане (СПГ)',
            4: 'Personal guarantee',
            5: 'We use new spare parts for repairs',
            6: 'Directions to us',
            7: 'Customer reviews',
            8: 'See all reviews',
             9: "Over 17 years of experience",
            10: "Industry specialists",
            11: "Quality repairs",
            12: "Professional car and van diagnostics"
,
        },
        'shortAdd': {
            1: 'Is your car no longer reliable on the road?',
            2: 'Come in for a complete suspension check so we can fix the problem.',
            3: 'Make an appointment',
        },
        'shortAdd2': {
            1: "Do you want to boost your car’s performance and save up to 9% on fuel?",
            2: "We can do it with ECU tuning, enhancing your vehicle’s performance and increasing power by up to 40%!",
            3: 'Contact us now',
        },
        'aboutUs': {
            1: 'About RNK Tech',
            2: 'We specialize in:',
            9: 'Thanks to our long-standing 360-degree expertise in all types of vehicle repairs, the name RNK Tech truly reflects who we are.',
            10: 'We provide accurate diagnoses, professional maintenance, and efficient repairs, using modern equipment and quality spare parts.',
            11: "Our team is always ready to assist you with clear advice and timely intervention.",
            // 12: "Проверке подвески на специализированном стенде",
            // 13: "Ремонте кондиционеров",
            // 14: "Замене масел и технических жидкостей",
            15: 'Our social media:',
        },
        'contactsPage': {
            'form': {
                1: 'Or describe your problem and we will call you back',
                2: 'Your phone*',
                3: 'Your name',
                4: 'RNK Tech...',
                5: 'Your car model and year',
                6: 'Citroen C6, 2018 year, front-wheel drive ',
                7: 'Tell us about your problem',
                8: 'For example: Knocking sounds are heard on potholes',
                9: 'Your request has been sent! We will call you back.',
                10: 'Send',
                11: '* This field is required',
				details: 'For a detailed consultation, call us right now!',
            },
            'contacts': {
                1: 'Contacts',
                2: 'Padova, Via Vicenza 21/b 35137',
                3: 'Mon-Fri: 8.30 – 12.30  14.30 — 18.30, Sat: 8.30 – 12.30',
				requisites: 'Банковские реквизиты:'
            },
            'form-info': {
                1: 'sss',
            },
        },
        'restorationLocale': {
            1: 'Services',
        },
        'QALocale': {
            oftenAsked: 'FAQ',
            newRack: 'Do you repair air conditioning compressors?',
            newRackDescription: 'No, but we do all types of air conditioner repairs',
            signsOfBroken: 'Can I come just for a check-up, without repair?',
            signsOfBrokenDescription: 'Of course, by booking an appointment.',
            qaQuestion1: 'Do you also work with electric or hybrid cars?',
            qaQuestion1Description: 'Yes, we have the experience and equipment to diagnose and repair air conditioning and suspension systems on electric or hybrid vehicles as well.',
            qaQuestion2: 'What types of suspensions do you repair?',
            qaQuestion2Description: 'We perform repairs on any type of suspension.',
            // qaQuestion3: '',
            // qaQuestion3Description: '',
            //qaQuestion4: 'Нужно ли менять масло в автоматической коробке передач?',
            //qaQuestion4Description: 'Да, даже при отсутствии проблем рекомендуется менять масло каждые 40 000–60 000 км, чтобы продлить срок службы коробки.',
            //qaQuestion5: 'Делаете ли вы адаптацию АКПП после замены масла?',
            //qaQuestion5Description: 'Да, мы проводим адаптацию коробки после замены масла, чтобы она работала корректно под ваш стиль вождения.',
            // qaQuestion6: 'Доп Вопрос 6',
            // qaQuestion6Description: 'Доп 6 описание',
            // qaQuestion7: 'Доп Вопрос 7',
            // qaQuestion7Description: 'Доп 7 описание',
            // qaQuestion8: 'Доп Вопрос 8',
            // qaQuestion8Description: 'Доп 8 описание',
        },
        'footer': {
            1: 'Сайт разработан при поддержке',
            2: ' при поддержке '
        }
    },
    'romanian': {
        'navigation': {
            0: '',
            1: 'Recensioni',
            2: 'Chi siamo',
            3: 'Servizi',
            4: 'Contatti',
        },
        'previewPage': {
            1: 'RNK Tech',
            2: 'Riparazioni auto e furgoni a 360°',
            3: 'Diagnostica avanzata, manutenzione completa, riparazione sospensioni, climatizzazione e centraline. 17 anni di esperienza a Padova.',
            4: 'Contattaci su WhatsApp',
            //5:'service auto de Încredere cu locație în Chișinău!'
        },
        'whyUs': {
            1: 'Perché dovresti scegliere noi?',
            // 2: 'Prezzi equi e trasparenti',
            3: '-',
            4: 'Personale qualificato',
            5: 'Ricambi di qualità',
            6: 'Vedi la posizione',
            7: 'Recensioni dei clienti',
            8: 'Tutte le recensioni',
            9: "Oltre 17 anni di esperienza",
            10: "Specialisti nel settore",
            11: "Riparazione di qualità",
            12: "Diagnosi professionale auto e furgoni",
        },
        'shortAdd': {
            1: "La tua auto non è più affidabile su strada?",
            2: "Venite a farci un controllo completo delle sospensioni, così possiamo risolvere il problema.",
            3: "Pianifica te stesso",
        },
        'shortAdd2': {
            1: "Voi potenziare la tua auto ed avere un risparmi di carburante fino al 9%",
            2: "Noi possiamo farlo con tuning centralina, modificando le prestazioni della tua auto fino a 40% di potenza in più!",
            3: "Contattaci",
        },
        'aboutUs': {
            1: 'Informazioni su RNK Tech',
            2: "Siamo specializzati e qualificati:",
            9: "Grazie alla nostra esperienza completa a 360° in ogni tipo di riparazione, il nome RNK Tech riflette davvero chi siamo.",
            10: "Forniamo diagnosi accurate, manutenzione professionale e riparazioni efficienti, utilizzando attrezzature moderne e ricambi di qualità.",
            11: "Operiamo sia con autovetture che con veicoli commerciali, offrendo soluzioni rapide per il vostro comfort e la vostra sicurezza su strada. Il nostro team è sempre pronto ad assistervi con consigli chiari e interventi tempestivi.",
            // 12: "Verificarea suspensiei pe stand specializat",
            // 13: "Reparația condiționerelor",
            // 14: "Schimb de uleiuri și lichide tehnice",
            15: 'I nostri social:',
        },//{
            //1: 'Informazioni su RNK Tech',
            //2: "Suntem specializați și pricepuți:",
            //9: "Cu o experiență solidă în reparația sistemelor de climatizare și suspensii auto, Bogdy Garage oferă servicii de încredere pentru șoferii din Chișinău.",
            //10: "Ne ocupăm de diagnosticare precisă, întreținere profesionistă și reparații eficiente, folosind echipamente moderne și piese de calitate.",
            //11: "Lucrăm atât cu autoturisme, cât și cu vehicule comerciale, oferind soluții rapide pentru confortul și siguranța ta pe drum. Echipa noastră este mereu gata să te ajute cu sfaturi clare și intervenții prompte.",
            // 12: "Verificarea suspensiei pe stand specializat",
            // 13: "Reparația condiționerelor",
            // 14: "Schimb de uleiuri și lichide tehnice",
            //15: 'Vezi lucrările noastre:',


        'contactsPage': {
            'form': {
                1: 'Oppure descrivici il tuo problema e ti richiameremo',
                2: 'Il tuo telefono*',
                3: 'Nome',
                4: 'RNK Tech...',
                5: 'Modello e anno dell auto',
                6: 'Citroen C6 2016',
                7: 'Descrivici il tuo problema.',
                8: 'Esempio: Ci sono percosse alle fosse',
                9: 'Richiesta inviata! Attendi un suono',
                10: 'Inviare',
                11: '* È necessario compilare almeno questo campo.',
				details: 'Per una consulenza dettagliata, chiamaci subito!',
            },
            'contacts': {
                1: 'Contatti',
                2: 'Padova, Via Vicenza 21/b 35137',
                3: 'Lun-Ven: 8.30 — 12.30  14.30 — 18.30, Sab: 8.30 – 12.30',
				requisites: 'Datele bancare:'
            },
    //        'bank-details': {
               // 1: 'Rechizite bancare:',
                //2: 'mun. Chisinau, sec. Ciocana, str. Milescu Spătaru 18',
                //3: 'Lu-Vi: 8:30 — 18:00',
            //},
            'form-info': {
                1: 'sss',
            }
        },
        'restorationLocale': {
            1: 'I nostri servizi',
        },
        'QALocale': {
            oftenAsked: 'Domande frequenti',
            newRack: 'Riparate i compressori dell aria condizionata?',
            newRackDescription: 'Riparazione tutti i tipi di climatizzatori',
            signsOfBroken: 'Posso venire solo per un controllo, senza riparazione?',
            signsOfBrokenDescription: 'Certamente, prenotando un appuntamento.',
            qaQuestion1: 'Lavorate anche con auto elettriche o ibride?',
            qaQuestion1Description: 'Sì, disponiamo dell esperienza e delle attrezzature necessarie per diagnosticare e riparare anche i sistemi di aria condizionata e sospensioni dei veicoli elettrici o ibridi.',
            qaQuestion2: 'Che tipo di sospensioni riparate?',
            qaQuestion2Description: 'Eseguiamo riparazione su qualsiasi tipo di sospensione.',
            //qaQuestion3: 'Che tipo di sospensioni riparate?',
            //qaQuestion3Description: 'Eseguiamo riparazione su qualsiasi tipo di sospensione.',
            //qaQuestion4: 'Trebuie schimbat uleiul din cutia automată?',
            //qaQuestion4Description: 'Da, chiar dacă nu apar probleme, se recomandă schimbarea uleiului la fiecare 40 000–60 000 km pentru a prelungi durata de viață a cutiei.',
            //qaQuestion5: 'Faceți adaptarea cutiei după schimbul de ulei?',
            //qaQuestion5Description: 'Da, efectuăm adaptarea cutiei după schimbul de ulei pentru ca aceasta să funcționeze corect în funcție de stilul dvs. de condus.',
            // qaQuestion6: 'Доп Вопрос 6',
            // qaQuestion6Description: 'Доп 6 описание',
            // qaQuestion7: 'Доп Вопрос 7',
            // qaQuestion7Description: 'Доп 7 описание',
            // qaQuestion8: 'Доп Вопрос 8',
            // qaQuestion8Description: 'Доп 8 описание',
        },
        'footer': {
            1: 'Site-ul a fost dezvoltat de către',
            2: " cu suportul "
        }
    }
}